import React, { useContext, useState } from 'react'
import "./setupChecklist.scss"

import LittleCircle from '../SetupDetailsUtilities/LittleCircle';
import {
    homePageActivated,
    channelCreated,
    contentPublished,
    publishedEvents,
    coursesPublished,
    membershipSubscriptionSetup,
    adminProfileCompleted,
    // calendarBooked,
    customizeBranding,
    productTourWatched,
    membersAdded,
    // membershipQuestionsConfigured,
    invitePageConfigured,
} from '../SetupDetailsUtilities/utils';
import CompletedCircle from '../SetupDetailsUtilities/CompletedCircle';
import { SetupBoardContext } from '../SetupBoard/SetupBoard';

export interface IListItemParams {
    text: string,
    onSelect: (index: number) => void,
    index: number,
    selected: boolean
    groupData: any
}

export interface ISetupChecklistParams {
    selectComp: any
    groupData: any
}

const CheckListItem: React.FC<IListItemParams> = (
    { text, onSelect, index, selected, groupData }
) => {
    const backgroundColor = selected ? 'selected' : '';
    const { courseExists, OnboardingEmailsSet, membershipQuestionsConfigured } = useContext(SetupBoardContext)


    function isCompleted(index: number, groupData: any) {
        switch (index) {
            case 1:
                // Community config
                return homePageActivated(groupData)
                    && channelCreated(groupData)
                    && contentPublished(groupData)
                    && publishedEvents(groupData);
            case 4:
                // courses setup
                return coursesPublished(groupData)
                    && courseExists;
            case 2:
                // community's subscriptions setup
                return membershipSubscriptionSetup(groupData);
            case 0:
                // Basic setup
                return adminProfileCompleted(groupData)
                    && productTourWatched(groupData)
                    // && calendarBooked(groupData)
                    && customizeBranding(groupData)
            case 3:
                // Add and Invite Members
                return membersAdded(groupData)
                    && OnboardingEmailsSet
                    && invitePageConfigured(groupData)
                    && membershipQuestionsConfigured(groupData)
            default:
                return false;
        }
    }

    const completed = isCompleted(index, groupData);

    return (

        <div
            onClick={() => onSelect(index)}
            className={`checklist-body-li ${backgroundColor}`}
        >
            {completed ? <CompletedCircle /> : <LittleCircle />}
            <span>{text}</span>
        </div>
    );
}

const SetupChecklist: React.FC<ISetupChecklistParams> = ({ selectComp, groupData }) => {
    const [selected, setSelected] = useState(0);

    const handleSelect = (index: number) => {
        setSelected(index);
        selectComp(index)
    };

    const checklistItems = [{
        text: "Basic Setup",
        index: 0,
        selected: 0,
    },
    {
        text: "Community",
        index: 1,
        selected: 1,
    },
    {
        text: "Courses",
        index: 4,
        selected: 4,
    },
    {
        text: "Subscriptions",
        index: 2,
        selected: 2,
    },
    {
        text: "Onboarding Setup",
        index: 3,
        selected: 3,
    }]

    return (
        <div className='checklist-body-wrapper'>
            <div className='checklist-header'>
                <img
                    src={require("../../../assets/img/setup-checklist.svg")}
                    alt="Setup Checklist IMG"
                    className='checklist-header-img'
                />
                <span className='checklist-header-title'>
                    Setup checklist
                </span>
            </div>

            <ul className="checklist-body-ul">
                {checklistItems.map((item) => (
                    <CheckListItem
                        key={item.index}
                        text={item.text}
                        index={item.index}
                        selected={selected === item.index}
                        onSelect={handleSelect}
                        groupData={groupData}
                    />
                ))}
            </ul>
        </div>
    )
}

export default SetupChecklist
